var productBlog = (function() {
  const productWrapper = document.querySelector(".blog-product");
  const productItems = document.querySelectorAll(".blog-product__item");

  function init() {
    getProductHandle();
  }

  function getProductHandle() {
    if(!productWrapper) return;

    productItems.forEach(function(item) {
      let handle = item.getAttribute("data-handle");
      fetch(`/products/${ handle }.js`, {
      })
        .then(response => response.json())
        .then(product => {
          item.innerHTML = renderProduct(product);
        })
    })
  }

  function renderProduct(product) {
    let productVariant = product.variants;
    let variant = productVariant.map(function(value) {
      return `
        <option value="${ value.id }"> ${ value.name } </option>
      `
    });

    let button = '';
    if(product.available == true) {
      button = `
      <button type="submit" name="add" class="button button--full-width button--primary">
        <span>Add to cart</span>
        <div class="loading-overlay__spinner hidden">
          <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
            <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
          </svg>
        </div>
      </button>
      `
    } else {
      button = `
      <button type="submit" name="add" class="button button--full-width button--primary" disabled>
        <span>Sold out</span>
      </button>
      `
    }

    return `
      <div class="blog-product__top">
        <img src="${ product.featured_image }" alt="${ product.title }">
      </div>
      <div class="blog-product__bottom">
        <div class="blog-product__title"> ${ product.title } </div>
        <div class="blog-product__price"> ${ Shopify.formatMoney(product.price, window.moneyFormat) } </div>
        <product-form>
          <form method="post" id="product-form--${ product.id }" action="/cart/add" accept-charset="UTF-8">
            <select name="id" class="blog-product__select"> ${ variant } </select>
            ${ button }
          </form>
        </product-form>
      </div>
    `
  }

  return {
    init: init,
  }
})();

window.addEventListener('load', function() {
  productBlog.init();
});
